import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphBuildState } from "../rewardGraphBuildState";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";

export class RewardWaypointOutputBlock extends RewardGraphNode {

    /**
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this._isUnique = true;
        this.registerInput("waypoint", RewardGraphConnectionPointTypes.Vector3);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardWaypointOutputBlock";
    }
    /**
     * Gets the reward input component
     */
    public get waypoint(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    protected override _buildBlock(state: RewardGraphBuildState) {
        state.waypointData = this.waypoint.getConnectedValue(state);
    }
}

RegisterClass("MELS.RewardWaypointOutputBlock", RewardWaypointOutputBlock);
